import { render } from "./fastBorrowAndReturn.vue?vue&type=template&id=1d514abc&scoped=true"
import script from "./fastBorrowAndReturn.vue?vue&type=script&lang=js"
export * from "./fastBorrowAndReturn.vue?vue&type=script&lang=js"

import "./fastBorrowAndReturn.vue?vue&type=style&index=0&id=1d514abc&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d514abc"]])

export default __exports__